export default "__VITE_ASSET__KXMl5$Qr__"